import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress, Tooltip } from "@mui/material";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import serverHost from "../../services/serverHost";
import { Grid } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorIcon from '@mui/icons-material/Error';
import HelpIcon from '@mui/icons-material/Help';
import { formatDateTime } from "../../helpers/helpers";

export default function Pronuncias({ unidadeId }) {
  const { notification, confirm } = useContext(AppContext);

  const [carregando, setCarregando] = useState(false);
  const [enviandoNotificacao, setEnviandoNotificacao] = useState(false);
  const [lista, setLista] = useState([]);
  const [profissionaisBusca, setProfissionaisBusca] = useState([]);
  const [profissionaisNotificar, setProfissionaisNotificar] = useState([]);
  const [pronunciaSelecionada, setPronunciaSelecionada] = useState({});
  const [filtrosProfissionais, setFiltrosProfissionais] = useState({});
  const [notificacao, setNotificacao] = useState({});
  const [comboEscolas, setComboEscolas] = useState([]);
  const [etapa, setEtapa] = useState('BUSCA_PROFISSIONAIS');  

  useEffect(() => {
    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = () => {
    api
    .get("escolas/listar", { ativas: true })
    .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const buscarProfissionais = (filtrosEnviar = filtrosProfissionais) => {
    setCarregando(true);
    setFiltrosProfissionais(filtrosEnviar);

    api
    .get("notificacoes/buscarProfissionais", filtrosEnviar)
    .then((profissionais) => {

      const profissionaisBusca = profissionais.filter(p => profissionaisNotificar.filter(pn => pn.id === p.id).length === 0);

      const umMesAtras = new Date();
      umMesAtras.setMonth(umMesAtras.getMonth() - 1);

      const tresMesesAtras = new Date();
      tresMesesAtras.setMonth(tresMesesAtras.getMonth() - 3);

      profissionaisBusca.forEach(p => {
        p.nomeEscola = `${p.usuarioNome} (${p.escolaNomeFantasia})`;
        p.ultimoAcessoApp = formatDateTime(p.ultimoAcessoAplicativo, "D/M/Y h:m:s");

        const ultimaUtilizacaoApp = new Date(p.ultimoAcessoAplicativo);

        if(p.podeReceberNotificacoes){
          if(ultimaUtilizacaoApp > umMesAtras){
            p.probabilidadeRecebimentoNotificacoes = (
              <Tooltip title="Alta: O profissional possui token para recebimento de notificações e utilizou o aplicativo recentemente.">
                <CheckCircle style={{color: 'darkgreen'}} />
              </Tooltip>
            );
          } else if(ultimaUtilizacaoApp > tresMesesAtras) {
            p.probabilidadeRecebimentoNotificacoes = (
              <Tooltip title="Média: O profissional possui token para recebimento de notificações, porém não utiliza o aplicativo há um tempo.">
                <HelpIcon style={{color: 'orange'}} />
              </Tooltip>
            );
          } else {
            p.probabilidadeRecebimentoNotificacoes = (
              <Tooltip title="Baixa: O profissional possui token para recebimento de notificações, porém não utiliza o aplicativo há um longo período.">
                <ErrorIcon style={{color: 'red'}} />
              </Tooltip>
            );
          }
        } else {
          p.probabilidadeRecebimentoNotificacoes = (
            <Tooltip title="Nula: O profissional não utiliza o aplicativo ou optou por não receber notificações.">
              <CancelIcon style={{color: 'black'}}/>
            </Tooltip>
          );
        }
      });

      setProfissionaisBusca(profissionaisBusca);
      setCarregando(false);
    })
    .catch((err) => {
      console.log(err);
      notification("error", "Não foi possível listar profissionais");
      setCarregando(false);
    });
  };

  const confirmarNotificacao = (notificacaoEnviar = notificacao) => {
    setNotificacao(notificacaoEnviar);

    if(!profissionaisNotificar.length) return notification("error", "Nenhum profissional selecionado.");

    confirm({
      title: "Confirma o envio da notificação?",
      label: `
        A notificação será enviada para ${profissionaisNotificar.length === 1 ?  '1 profissional.' 
            : `${profissionaisNotificar.length} profissionais.`} Não será possível desfazer.`,
      onConfirm: () => enviarNotificacao(notificacaoEnviar),
    });
  }

  const enviarNotificacao = (notificacaoEnviar) => {    
    if(!profissionaisNotificar.length) return notification("error", "Nenhum profissional selecionado.");
    if(!notificacaoEnviar?.titulo || !notificacaoEnviar?.mensagem) return notification("error", "Notificação não definida.");

    setEnviandoNotificacao(true);

    const profissionais = [];

    profissionaisNotificar.forEach(p => profissionais.push(p.id));

    const dadosNotificacao = {
      profissionais,
      titulo: notificacaoEnviar.titulo,
      mensagem: notificacaoEnviar.mensagem
    }

    api
    .post("notificacoes/manualProfissionais", dadosNotificacao)
    .then(() => {
      notification("success", "Requisição de notificação enviada");

      setEtapa('NOTIFICACAO_ENVIADA');

      setEnviandoNotificacao(false);
    })
    .catch((err) => {
      console.log(err);
      notification("error", "Não foi possível enviar a notificacao");
      setEnviandoNotificacao(false);
    });
  }

  const adicionarProfissionalNotificacao = (profissional) => {
    if(!profissional.podeReceberNotificacoes) return notification('error', 'Profissional não habilidade para receber notificações.')

    const profissionaisNotificarAtualizar = [...profissionaisNotificar];

    profissionaisNotificarAtualizar.push(profissional);

    const profissionaisBuscaAtualizar = profissionaisBusca.filter(p => p.id !== profissional.id);

    setProfissionaisNotificar(profissionaisNotificarAtualizar);
    setProfissionaisBusca(profissionaisBuscaAtualizar);
  };

  const removerProfissionalNotificacao = (profissional) => {
    const profissionaisNotificarAtualizar = profissionaisNotificar.filter(p => p.id !== profissional.id);

    setProfissionaisNotificar(profissionaisNotificarAtualizar);
  }

  const enviarNovaNotificacao = () => {
    setEtapa('BUSCA_PROFISSIONAIS');
    setFiltrosProfissionais({});
    setProfissionaisBusca([]);
    setProfissionaisNotificar([]);
    setNotificacao({});
  }

  const filtros = {
    title: "Buscar profissionais",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: filtrosProfissionais.nome,
      },
      email: {
        label: "Email",
        type: "text",
        space: 4,
        value: filtrosProfissionais.email,
      },
      escola: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 4,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtrosProfissionais.escola,
      },
    },
    submit: {
      label: "Buscar",
      action: buscarProfissionais,
    }
  };

  const fConfirmarProfissionais = {
    title: "Confirmar escolha de profissionais e continuar",
    form: {
      nome: {
        label: "Profissionais a notificar",
        type: "text",
        value: profissionaisNotificar.length > 0 ? profissionaisNotificar.length.toString() : '(nenhum)',
        readOnly: true
      },
    },
    submit: profissionaisNotificar.length > 0 ? {
      label: "Confirmar",
      action: () => setEtapa('ESCRITA_NOTIFICACAO'),
    } : undefined
  };

  const fNotificacao = {
    title: "Notificacao",
    form: {
      titulo: {
        label: "Título",
        type: "text",
        value: notificacao.titulo,
        required: true,
        readOnly: !(etapa === 'ESCRITA_NOTIFICACAO')
      },
      mensagem: {
        label: "Mensagem",
        type: "textarea",
        value: notificacao.mensagem,
        required: true,
        readOnly: !(etapa === 'ESCRITA_NOTIFICACAO')
      }
    },
    submit: etapa === 'ESCRITA_NOTIFICACAO' && !enviandoNotificacao ? {
      label: "Confirmar",
      action: confirmarNotificacao,
    } : undefined,
    customActions: etapa === 'ESCRITA_NOTIFICACAO' ? [{
      label: "Editar lista de profissionais",
      action: () => setEtapa('BUSCA_PROFISSIONAIS'),
    }] : [{
      label: 'Enviar nova notificação',
      action: enviarNovaNotificacao
    }]
  };

  if(etapa === 'NOTIFICACAO_ENVIADA'){
    fNotificacao.form.resultado = {
      type: 'component',
      value: (
        <>
          <div style={{color: 'darkgreen', fontWeight: 'bolder'}}>Requisição enviada com sucesso para o serviço de notificações.</div>
          <div style={{fontSize: '12px'}}>Dependendo da quantidade de profissionais selecionados, as notificações podem demorar um pouco para chegar aos dispositivos.</div>
        </>
      )
    }
  }

  if(etapa === 'ESCRITA_NOTIFICACAO' && enviandoNotificacao){
    fNotificacao.form.enviando = {
      type: 'component',
      value: (
        <>
          <CircularProgress/>
        </>
      )
    }
  }

  const tBuscaProfissionais = {
    title: "Profissionais localizados",
    columns: [
      {
        name: "nomeEscola",
        label: "Nome (escola)",
      },
      {
        name: "ultimoAcessoApp",
        label: "Último acesso ao aplicativo"
      },
      {
        name: "probabilidadeRecebimentoNotificacoes",
        label: "Probabilidade de recebimento de notificações",
      }
    ],
    actions: [
      {
        name: "plus-circle",
        icon: "zmdi zmdi-plus-circle",
        action: adicionarProfissionalNotificacao,
      },
    ],
    array: profissionaisBusca,
  };

  const tProfissionaisNotificar = {
    title: "Profissionais a notificar",
    columns: [
      {
        name: "nomeEscola",
        label: "Nome (escola)",
      },
      {
        name: "probabilidadeRecebimentoNotificacoes",
        label: "Probabilidade de recebimento de notificações",
      }
    ],
    actions: etapa === 'BUSCA_PROFISSIONAIS' ? [
      {
        name: "close-circle",
        icon: "zmdi zmdi-close-circle",
        action: removerProfissionalNotificacao,
      },
    ] : [],
    array: profissionaisNotificar,
  };

  return (
    <div>
      {etapa === 'BUSCA_PROFISSIONAIS' &&
        <>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Form formData={filtros} />
            </Grid>
            <Grid item xs={3}>
              <Form formData={fConfirmarProfissionais} />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ActionTable structure={tBuscaProfissionais} />
            </Grid>
            <Grid item xs={6}>
              <ActionTable structure={tProfissionaisNotificar} />
            </Grid>
          </Grid>
        </>
      }
      {etapa === 'ESCRITA_NOTIFICACAO' &&
        <>
          <Form formData={fNotificacao} />
          <ActionTable structure={tProfissionaisNotificar} />
        </>
      }
      {etapa === 'NOTIFICACAO_ENVIADA' &&
        <>
          <Form formData={fNotificacao} />
          <ActionTable structure={tProfissionaisNotificar} />
        </>
      }
    </div>
  );
}
